import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyOwnershipSource } from '../propertyEndpoints'

/**
 * Whether this property's co-owner set is written from a listing request's declared
 * owners, which makes the wizard's Ownership step read-only.
 *
 * The answer is a fact about how the property was created, so it never changes for a
 * given property — but it is not cached forever: a property created THIS session
 * must not be answered from a pre-creation cache entry.
 */
export function usePropertyOwnershipSourceQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.ownershipSource(toValue(id)),
    queryFn: () => getPropertyOwnershipSource(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
